import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["panel", "trigger", "overlay"]

  connect() {
    this.isOpen = false
    this._handleKeydown = this._handleKeydown.bind(this)
    this._handleOutsideClick = this._handleOutsideClick.bind(this)
    document.addEventListener("keydown", this._handleKeydown)
    document.addEventListener("click", this._handleOutsideClick)
  }

  disconnect() {
    document.removeEventListener("keydown", this._handleKeydown)
    document.removeEventListener("click", this._handleOutsideClick)
  }

  toggle(event) {
    event.stopPropagation()
    if (this.isOpen) {
      this._close()
    } else {
      this._open()
    }
  }

  close() {
    this._close()
  }

  // Private

  _open() {
    this.isOpen = true
    this.panelTarget.classList.add("app-switcher-panel--open")
    this.triggerTarget.classList.add("app-switcher-trigger--active")
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.add("app-switcher-overlay--visible")
    }
    // Prevent body scroll on mobile
    if (this._isMobile()) {
      document.body.style.overflow = "hidden"
    }
  }

  _close() {
    this.isOpen = false
    this.panelTarget.classList.remove("app-switcher-panel--open")
    this.triggerTarget.classList.remove("app-switcher-trigger--active")
    if (this.hasOverlayTarget) {
      this.overlayTarget.classList.remove("app-switcher-overlay--visible")
    }
    document.body.style.overflow = ""
  }

  _handleKeydown(event) {
    if (event.key === "Escape" && this.isOpen) {
      this._close()
    }
  }

  _handleOutsideClick(event) {
    if (!this.isOpen) return
    if (this.element.contains(event.target)) return
    this._close()
  }

  _isMobile() {
    return window.matchMedia("(max-width: 767px)").matches
  }
}
